export default __webpack_public_path__ + "static/police-news-66667e3bc33d94799470346c91f8f3cb.jpeg";